import { useState } from "react";

let _setOpen = null;
let _setContent = null;
let _setMaxWidth = null;

export function openModal(node, { maxWidth = "900px" } = {}) {
  _setContent && _setContent(node);
  _setMaxWidth && _setMaxWidth(maxWidth);
  _setOpen && _setOpen(true);
}

export function closeModal() {
  _setOpen && _setOpen(false);
}

export default function Modal() {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState(null);
  const [maxWidth, setMaxWidth] = useState("900px");

  _setOpen = setOpen;
  _setContent = setContent;
  _setMaxWidth = setMaxWidth;

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex justify-center items-start md:items-center p-2 md:p-6 booking-modal-backdrop"
      style={{ background: "rgba(0,0,0,0.45)", backdropFilter: "blur(4px)" }}
      onMouseDown={closeModal}
    >
      <div
        className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-xl w-full max-h-[90vh] overflow-auto booking-modal-content"
        style={{ maxWidth }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {typeof content === "function" ? content() : content}
      </div>
    </div>
  );
}
